import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const UIContext = createContext(null);

// Global UI state: mobile menu, search overlay and toast notifications.
export function UIProvider({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [toasts, setToasts] = useState([]);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
    setSearchOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = menuOpen || searchOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen, searchOpen]);

  const toast = useCallback((message, type = 'success') => {
    const id = Date.now() + Math.random();
    setToasts((t) => [...t, { id, message, type }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 3200);
  }, []);

  return (
    <UIContext.Provider value={{ menuOpen, setMenuOpen, searchOpen, setSearchOpen, toast }}>
      {children}
      <div className="eg-toasts">
        {toasts.map((t) => (
          <div key={t.id} className={`eg-toast eg-toast--${t.type}`}>
            {t.message}
          </div>
        ))}
      </div>
    </UIContext.Provider>
  );
}

export const useUI = () => useContext(UIContext);
